// extracted by mini-css-extract-plugin
export default {"item":"Content_item__z6SpT","empty":"Content_empty__iFa4y"};